var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};
var gray = '#424242';
var darkGray = '#212121';

function white(percent) {
  return "rgba(255,255,255,".concat((percent / 100).toFixed(2), ")");
}

var colorTeal = teal[500];
var colorTealDark = teal[700];
var theme = {
  overrides: {
    Breadcrumbs: {
      breadcrumb: {
        color: '#999'
      }
    },
    Grid: {
      paper: {
        backgroundColor: gray,
        borderColor: gray,
        color: white(87)
      },
      toolbar: {
        color: white(87),
        borderBottomColor: white(20)
      },
      toolbarActions: {
        color: white(50)
      },
      toolbarMenuHead: {
        borderBottomColor: white(10)
      },
      toolbarMenuHeadPlus: {
        color: colorTeal
      },
      toolbarMenuBoot: {
        borderTopColor: white(10)
      },
      toolbarMenuBootButton: {
        color: colorTeal
      },
      toolbarMenuEmpty: {
        color: white(50)
      },
      toolbarMenuActive: {
        backgroundColor: colorTeal,
        color: '#fff',
        '&:hover': {
          backgroundColor: teal[400]
        },
        '& button': {
          color: '#fff'
        }
      },
      body: {
        borderBottomColor: white(20)
      },
      td: {
        borderBottomColor: white(20)
      },
      tr: {
        '&:nth-child(2n+1)': {
          backgroundColor: 'rgba(0,0,0,0.08)'
        },
        '&:hover': {
          backgroundColor: white(5)
        }
      },
      selected: {
        color: '#fff',
        backgroundColor: "".concat(colorTeal, " !important")
      },
      resize: {
        '&:before': {
          backgroundColor: white(10)
        }
      },
      cellHead: {
        color: white(50)
      },
      cellHeadSortLabel: {
        color: white(50)
      },
      loading: {
        backgroundColor: 'rgba(0,0,0,0.2)'
      }
    },
    TableView: {
      paper: {
        backgroundColor: gray,
        borderColor: gray,
        color: white(70)
      }
    },
    DangerButton: {
      root: {
        backgroundColor: '#e45959',
        '&:disabled': {
          color: 'rgba(255, 255, 255, 0.26)',
          backgroundColor: 'rgba(121, 121, 121, 0.12)'
        }
      }
    },
    GridView: {
      grid: {
        color: 'rgba(255,255,255,0.87)'
      }
    },
    GridViewHeader: {
      resize: {
        '&:before': {
          backgroundColor: white(10)
        }
      }
    },
    GridViewHeaderMenu: {
      menu: {
        backgroundColor: '#424242',
        color: white(70)
      },
      toggle: {
        color: white(70)
      }
    },
    GridViewPager: {
      select: {
        color: white(70)
      }
    },
    GridViewToolbar: {
      actions: {
        color: '#999'
      },
      toolbar: {
        borderBottomColor: white(20),
        color: '#fff'
      },
      dropdownColumn: {
        color: white(70)
      },
      dropdownEmpty: {
        color: white(70)
      },
      dropdownHead: {
        color: white(90)
      }
    },
    Main: {
      '@global': {
        '::-webkit-scrollbar-corner': {
          background: white(5)
        },
        '::-webkit-scrollbar-thumb': {
          background: white(20)
        },
        '::-webkit-scrollbar-thumb:hover': {
          background: white(50)
        },
        '::-webkit-scrollbar-track': {
          background: white(5)
        },
        a: {
          color: '#fff'
        },
        body: {
          backgroundColor: '#212121',
          color: white(90)
        }
      },
      content: {
        backgroundColor: '#212121'
      },
      header: {
        borderBottomColor: '#009688'
      },
      headerToolbar: {
        backgroundColor: '#303030'
      },
      headerTextColor: {
        color: colorTeal
      }
    },
    Sidebar: {
      menu: {
        backgroundColor: '#303030',
        borderColor: white(10)
      },
      item: {
        color: '#999'
      },
      active: {
        backgroundColor: colorTeal
      },
      submenu: {
        backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.2), transparent 25%, transparent 75%, rgba(0, 0, 0, 0.2))'
      },
      version: {
        color: white(50)
      }
    },
    Loader: {
      wrapper: {
        background: darkGray
      },
      progress: {
        color: white(50)
      }
    },
    Login: {
      container: {
        backgroundColor: '#212121',
        color: white(90)
      },
      title: {
        color: white(90)
      },
      link: {
        color: white(90)
      },
      inputLabel: {
        color: white(70),
        '&$inputLabelFocused': {
          color: white(90)
        }
      }
    },
    Recovery: {
      container: {
        backgroundColor: '#212121',
        color: white(90)
      },
      title: {
        color: white(90)
      },
      link: {
        color: white(90)
      },
      inputLabel: {
        color: white(70),
        '&$inputLabelFocused': {
          color: white(90)
        }
      }
    },
    MuiCheckbox: {
      colorPrimary: {
        color: white(50),
        '&$checked': {
          color: colorTeal
        }
      }
    },
    MuiRadio: {
      colorPrimary: {
        color: white(50),
        '&$checked': {
          color: colorTeal
        }
      }
    },
    MuiButton: {
      contained: {
        '&$disabled': {
          backgroundColor: 'rgba(121, 121, 121, 0.12)',
          color: 'rgba(255, 255, 255, 0.26)'
        }
      },
      containedPrimary: {
        backgroundColor: colorTeal,
        color: 'white',
        '&:hover': {
          backgroundColor: colorTealDark
        }
      },
      textPrimary: {
        color: colorTeal
      },
      textSecondary: {
        color: white(50)
      }
    },
    MuiIconButton: {
      root: {
        color: '#999'
      },
      colorPrimary: {
        '&:hover': {
          backgroundColor: white(5)
        }
      }
    },
    MuiInput: {
      underline: {
        '&:before, &:after': {
          borderBottomColor: "".concat(white(20), " !important")
        }
      }
    },
    MuiInputBase: {
      root: {
        color: '#fff'
      },
      input: {
        '&:-webkit-autofill': {
          transition: 'background-color 5000s ease-in-out 0s',
          '-webkit-text-fill-color': '#fff !important',
          caretColor: '#fff !important'
        },
        '&:-internal-autofill-selected': {
          transition: 'background-color 5000s ease-in-out 0s',
          '-webkit-text-fill-color': '#fff !important',
          caretColor: '#fff !important'
        }
      }
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: white(10)
      },
      root: {
        '&:hover': {
          '& $notchedOutline': {
            borderColor: white(20)
          },
          '&:hover $input$disabled': {
            borderColor: white(70)
          }
        },
        '&$focused': {
          '& $notchedOutline': {
            borderColor: white(50)
          },
          '&:hover': {
            '& $notchedOutline': {
              borderColor: white(50)
            }
          }
        },
        '&$disabled': {
          opacity: 0.5,
          '& $notchedOutline': {
            borderColor: white(10)
          },
          '&:hover': {
            '& $notchedOutline': {
              borderColor: white(20)
            }
          },
          '&$focused': {
            '& $notchedOutline': {
              borderColor: white(50)
            },
            '&:hover': {
              '& $notchedOutline': {
                borderColor: white(50)
              }
            }
          }
        }
      },
      input: {
        '&$disabled': {
          // opacity: 0.5,
          borderColor: white(70),
          color: white(70),
          cursor: 'not-allowed'
        }
      }
    },
    MuiInputLabel: {
      outlined: {
        '&$disabled': {
          opacity: 0.5,
          color: white(70)
        }
      }
    },
    MuiMenuItem: {
      root: {
        color: white(70)
      }
    },
    MuiTabs: {
      root: {
        backgroundColor: gray
      }
    },
    MuiTab: {
      root: {
        maxWidth: 300
      },
      textColorPrimary: {
        color: white(90),
        '&.Mui-selected': {
          color: teal[400]
        }
      }
    },
    MuiTableCell: {
      head: {
        borderBottomColor: white(20),
        color: white(70)
      },
      body: {
        color: white(90)
      },
      root: {
        borderBottomColor: white(10)
      }
    },
    MuiTablePagination: {
      actions: {
        color: white(70),
        '& button[disabled]': {
          color: white(20)
        }
      },
      caption: {
        color: white(90)
      },
      selectIcon: {
        color: white(70)
      },
      input: {
        color: white(70)
      }
    },
    MuiTableRow: {
      root: {
        height: 40,
        '&:nth-child(2n+1)': {
          backgroundColor: white(5)
        },
        '&$selected': {
          backgroundColor: "".concat(white(20), " !important")
        }
      }
    },
    MuiTableSortLabel: {
      root: {
        color: white(70),
        '&:hover': {
          color: '#fff'
        },
        '&:focus': {
          color: white(70)
        },
        '&$active:hover': {
          color: '#fff'
        },
        '&$active': {
          color: white(70)
        }
      },
      active: {
        color: '#fff'
      },
      icon: {
        color: "".concat(white(70), " !important")
      }
    },
    MuiTypography: {
      body2: {
        color: white(90)
      },
      caption: {
        color: white(90)
      },
      h1: {
        color: white(90),
        fontSize: 20,
        fontWeight: 400,
        marginBottom: 16
      },
      colorTextSecondary: {
        color: white(90)
      }
    },
    MuiFormControl: {
      root: {
        marginTop: 20,
        '&:first-child': {
          marginTop: 0
        }
      },
      marginDense: {
        marginTop: 12
      }
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 14
      }
    },
    MuiFormLabel: {
      root: {
        color: white(70),
        '&$focused': {
          color: white(70)
        }
      },
      asterisk: {
        color: '#ff2525',
        fontWeight: 500
      }
    },
    MuiPaper: {
      root: {
        color: white(70)
      }
    },
    MuiPickersDay: {
      day: {
        color: white(70)
      },
      daySelected: {
        backgroundColor: colorTeal
      },
      current: {
        color: white(70)
      }
    },
    MuiPickersCalendarHeader: {
      dayLabel: {
        color: white(50)
      }
    },
    MuiPickersYear: {
      root: {
        '&:focus': {
          color: white(70)
        }
      },
      yearSelected: {
        color: white(70)
      }
    },
    MuiPickersMonth: {
      root: {
        '&:focus': {
          color: white(70)
        }
      },
      monthSelected: {
        color: white(70)
      }
    },
    InventoryModule: {
      title: {
        color: white(70)
      },
      subTitle: {
        color: white(70)
      }
    },
    Select: {
      valueContainer: {
        '& + div > span': {
          backgroundColor: white(10)
        }
      }
    },
    MuiSelect: {
      icon: {
        color: white(70)
      }
    },
    MuiListItem: {
      root: {
        '&$selected': {
          backgroundColor: colorTeal
        }
      }
    },
    PrivateTabIndicator: {
      colorSecondary: {
        backgroundColor: colorTeal
      },
      colorPrimary: {
        backgroundColor: colorTeal
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: colorTeal
      }
    },
    MonitoringModule: {
      title: {
        color: white(80)
      },
      subTitle: {
        color: white(70)
      }
    },
    DateBetween: {
      toggle: {
        borderColor: white(10),
        '&:hover': {
          borderColor: white(20)
        }
      },
      toggleLabel: {
        backgroundColor: '#212121',
        color: white(50)
      },
      toggleIcon: {
        color: white(70)
      },
      datepickerTd: {
        borderColor: '#424242'
      },
      otherDay: {
        borderColor: '#424242',
        '& > button': {
          color: white(80)
        }
      }
    },
    FastFilter: {
      label: {
        color: white(70)
      }
    },
    LoadsRegionalCount: {
      title: {
        color: white(70),
        borderBottomColor: white(20)
      },
      summary: {
        color: white(70),
        borderRightColor: white(20)
      }
    },
    DevicesLoadingCount: {
      title: {
        color: white(70),
        borderBottomColor: white(20)
      },
      body: {
        color: white(70)
      }
    },
    QuoteChart: {
      current: {
        borderBottomColor: white(100)
      }
    },
    Field: {
      disabledInput: {
        background: gray
      },
      clearButton: {
        '&.MuiIconButton-root.Mui-disabled': {
          color: 'rgba(204, 204, 204, 0.5)'
        }
      }
    }
  },
  palette: {
    background: {
      default: '#212121',
      paper: '#424242'
    },
    primary: {
      contrastText: '#fff',
      dark: '#212121',
      light: '#616161',
      main: '#424242'
    },
    secondary: {
      contrastText: '#fff',
      dark: '#00796B',
      light: '#009688',
      main: '#00897B'
    }
  },
  typography: {
    htmlFontSize: 16
  }
};
export default theme;